// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-login-v3 .panel[data-v-0e0d6e88] {\n  width: 600px;\n  background-color: initial;\n}\n.page-login-v3 .panel .panel-body[data-v-0e0d6e88] {\n  padding: 30px 40px 40px;\n}", ""]);
// Exports
module.exports = exports;
